// Module
var code = "<page-header title=\"'Settings'\" breadcrumbs=\"[{label:'Settings', link:'portainer.settings'}, 'Edge Compute']\" reload=\"true\"> </page-header>\n\n<div class=\"row\">\n  <div class=\"col-sm-12\" ng-if=\"$ctrl.settings\">\n    <settings-edge-compute on-submit=\"($ctrl.onSubmitEdgeCompute)\" settings=\"($ctrl.settings)\"></settings-edge-compute>\n  </div>\n</div>\n";
// Exports
var _module_exports = code;;
var path = 'app/portainer/views/settings/edge-compute/settingsEdgeCompute.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;